import script from "./Company-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Company-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"

import "./Company-Questionnaire-Main.vue?vue&type=style&index=0&id=31e75518&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e75518"]])

export default __exports__